import apiPDO from '@/api/pdo';
import apiOption from '@/api/option';

const defaultState = () => ({
	listPDO: [],
	detailPDO: '',
	listSupplier: [],
	listWarehouse: [],
	OptionStatusPDO: [],
	PDOforAccept: [],
	pdoPagination: '',
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
	productPDO(state){
		if (state.detailPDO) {
			return state.detailPDO.pdo_detail.map((el) => {
				el.quantity = el.pdo_detail_quantity_sent
				return el
			})
		}
	}
};

const mutations = {
	setPDO(state, data) {
		state.listPDO = data.data
		state.pdoPagination = data.pagination;
	},
	setDetailPDO(state, data) {
		state.detailPDO = data
	},
	setOptionStatusPDO(state, data) {
		state.OptionStatusPDO = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	setListSupplier(state, data) {
		state.listSupplier = data
	},
	setListWarehouse(state, data) {
		state.listWarehouse = data
	},
	setPDOforAccept(state, data) {
		state.PDOforAccept = data
	},
	saveResponse(state, data) {
		state.response = data
		state.responseError = {}
		state.alert = ''
		state.alertMultiple = []
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataPDO(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getPDO({ commit }, params) {
		return new Promise((resolve) => {
			apiPDO.getPDO(params).then(({ data: { data } }) => {
				commit('setPDO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setPDO', { data: [], pagination: {} });
			});
		});
	},
	getPDOAll({ commit }, params) {
		return new Promise((resolve) => {
			apiPDO.getPDOAll(params).then(({ data: { data } }) => {
				commit('setPDO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setPDO', { data: [], pagination: {} });
			});
		});
	},
	getDetailPDO({ commit, dispatch }, params) {
		apiPDO.getDetailPDO(params).then(({ data: { data } }) => {
			commit('setDetailPDO', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailPDO', {});
		});
	},
	getOptionSupplier({ commit }) {
		apiOption.getOptionSupplier().then(({ data: { data } }) => {
			commit('setListSupplier',data.results);
		}).catch(() => {
			commit('setListSupplier', []);
		});
	},
	getOptionWarehouse({ commit }) {
		apiOption.getOptionWarehouse().then(({ data: { data } }) => {
			commit('setListWarehouse',data.results);
		}).catch(() => {
			commit('setListWarehouse', []);
		});
	},
	getOptionPDOforAccept({ commit }) {
		apiOption.getOptionPDOforAccept().then(({ data: { data } }) => {
			commit('setPDOforAccept',data.results);
		}).catch(() => {
			commit('setPDOforAccept', []);
		});
	},
	getOptionStatusPDO({ commit }) {
		return new Promise((resolve) => {
			apiPDO.getOptionStatus().then(({ data: { data } }) => {
				commit('setOptionStatusPDO',data.results);
				resolve()
			}).catch(() => {
				commit('setOptionStatusPDO', []);
			});
		});
	},
	async exportPDO({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiPDO.exportPDO(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data penerimaan barang'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportPDOAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiPDO.exportPDOAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data penerimaan barang'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async receivePDO({ commit, dispatch }, params) {
		await apiPDO.receivePDO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal proses penerimaan barang'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};